export default __webpack_public_path__ + "static/media/project-04.3014b1ec.jpg";